import { ReactNode, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { AddAudiologistToSupplierDialog } from "../dialogs/add-audiologist-to-supplier-dialog";
import { useToast } from "../hooks/use-toast";
import { InviteAudiologistContext } from "./invite-audiologist-context";

interface Props {
  children: ReactNode;
}

export function InviteAudiologistContextProvider({ children }: Props) {
  const [addAudiologistToSupplierDialogOpen, setAddAudiologistToSupplierDialogOpen] = useState<boolean>(false);
  const { pushCustomSuccessToast } = useToast();
  const { t } = useTranslation(["toasts"]);

  const onClose = useCallback(
    (success: boolean) => {
      if (success) {
        pushCustomSuccessToast(t("toasts:toasts.invite.succes"));
      }
      setAddAudiologistToSupplierDialogOpen(false);
    },
    [pushCustomSuccessToast, setAddAudiologistToSupplierDialogOpen, t]
  );

  return (
    <InviteAudiologistContext.Provider value={{ open: addAudiologistToSupplierDialogOpen, setOpen: setAddAudiologistToSupplierDialogOpen }}>
      {children}
      <AddAudiologistToSupplierDialog onClose={onClose} open={addAudiologistToSupplierDialogOpen} />
    </InviteAudiologistContext.Provider>
  );
}
